// Headless export registration for the Open-ended family. Keys `oe`/`cx`/`scx`/`cn`
// are the legacy pptx.coffee dispatch keys (Option A) — all four route to one
// dispatcher with the sub-view in params (base-key + sub-mode, no compound keys).
// params.viewMode = report-param `oe{key}.viewMode` (defaults mirror the legacy
// libs: combo cx/cn → sunburst, scx → chart, oe → verbatim — the oe default is
// runtime-dependent on live, but only wordcloud/sunburst/treemap rasterize anyway).
// params.wcConfig = report-param `wc{id}` (wordcloud preset/config).
// params.scope = combo drill-down state. PNG-less viewModes → explicit error event.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/10-oe.md

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import OeDispatcher from '@aytm/app/stats/page/question-views/oe/components/OeDispatcher'

const DEFAULT_VIEW_MODES: Record<string, string> = {
  cx: 'sunburst',
  cn: 'sunburst',
  scx: 'chart',
  oe: 'verbatim'
}

const oeEntry: ExportableChart = {
  Component: OeDispatcher,
  toProps: (data: any, params: any) => {
    const qType = data.qType || params.chartType

    return {
      qType,
      questionKey: data.questionKey,
      id: data.id,
      answer: data.answer,
      answerVariants: data.answerVariants,
      levels: data.levels,
      format: data.format || {},
      colorTheme: data.colorTheme,
      chartLegendMode: data.chartLegendMode,
      features: data.features || {},
      viewMode: params.viewMode || DEFAULT_VIEW_MODES[qType] || 'verbatim',
      chartMode: params.chartMode,
      scope: params.scope || [],
      wcConfig: params.wcConfig || {},
      width: Number(params.width) || 746,
      // 0 → wordcloud branch falls back to the legacy orientation ratio.
      height: Number(params.height) || 0
    }
  }
}

ExportableCharts.register('oe', oeEntry)
ExportableCharts.register('cx', oeEntry)
ExportableCharts.register('scx', oeEntry)
ExportableCharts.register('cn', oeEntry)
